import "core-js/modules/es.object.to-string";
import { ROUTE_NAME } from '@/lib/constant';
export default [{
  path: '/shop/order_list_o/:activityId?',
  name: ROUTE_NAME.SHOP_ORDER_LIST_OLD,
  meta: {
    name: '订单列表',
    needBinding: true
  },
  component: function component() {
    return import(
    /* webpackChunkName: 'shop' */
    '@/pages/shop/orderList.vue');
  }
}, {
  path: '/shop/order_list/:activityId?',
  name: ROUTE_NAME.SHOP_ORDER_LIST,
  meta: {
    name: '订单列表',
    needBinding: true
  },
  component: function component() {
    return import(
    /* webpackChunkName: 'shop' */
    '@/pages/shop/newOrderList.vue');
  }
}, {
  path: '/shop/logistic/:serialNumber',
  name: ROUTE_NAME.SHOP_LOGISTIC,
  meta: {
    name: '物流信息',
    needBinding: true
  },
  component: function component() {
    return import(
    /* webpackChunkName: 'shop' */
    '@/pages/shop/logistic.vue');
  }
}, {
  path: '/shop/detail_o/:orderId',
  name: ROUTE_NAME.SHOP_ORDER_DETAIL_O,
  meta: {
    name: '订单详情',
    needBinding: true
  },
  component: function component() {
    return import(
    /* webpackChunkName: 'shop' */
    '@/pages/shop/orderDetailO.vue');
  }
}, {
  path: '/shop/detail/:orderId',
  name: ROUTE_NAME.SHOP_ORDER_DETAIL,
  meta: {
    name: '订单详情',
    needBinding: true
  },
  component: function component() {
    return import(
    /* webpackChunkName: 'shop' */
    '@/pages/shop/orderDetail.vue');
  }
}];